import { render } from "./AnalysisPage.vue?vue&type=template&id=536a79b7"
import script from "./AnalysisPage.vue?vue&type=script&lang=js"
export * from "./AnalysisPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__